import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators'; // fancy pipe-able operators
import { EnvService, SentryService } from '../services';

@Injectable({ providedIn: 'root' })
export class HttpLoggingInterceptor implements HttpInterceptor {
  constructor(private envService: EnvService, private sentryService: SentryService) {}

  log(message: string, dataKey: string, data: any) {
    if (this.envService.enableDebug) {
      console.log(message, data);
    } else {
      this.sentryService.addBreadcrumb({
        category: 'API',
        message,
        level: 'info',
        data: { [dataKey]: data },
      });
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.log('REQUEST', 'request', { ...request, Authorization: request.headers.get('Authorization') });

    return next.handle(request).pipe(
      tap({
        next: (response) => {
          if (response instanceof HttpResponse) {
            return this.log('RESPONSE', 'response', response);
          }
        },
        error: (error) => this.log('ERROR', 'error', error),
      })
    );
  }
}
